<div class="result">
  <!-- Imagen del resultado -->
  <section class="result-image--section">
    <!-- Mostrar link a la imagen, ya que este es el clipping -->
    <a [routerLink]="['/', tenantSlug, item.idEncriptado]" target="_blank">
      <img [src]="item.fotoExists ? item.fotoTemp : 'assets/img/noimage.png'"
            [attr.offset]="100" alt="result" class="image">
    </a>
  </section>

  <!-- Información del impacto -->
  <section class="result-info--section">
    <!-- Badges condicionales -->
    <div *ngIf="xlabel === 1" class="badge--container">
      <!-- <span class="" [ngClass]="{
        'bg-adp-blue-100 text-adp-blue-800 border-adp-blue-400': item.idPlataforma === 5, 
        'bg-adp-orange-100 text-adp-orange-800 border-adp-orange-400': item.idPlataforma === 3, 
        'bg-adp-yellow-100 text-adp-yellow-800 border-adp-yellow-300': item.idPlataforma === 9,
        'bg-adp-cyan-100 text-adp-cyan-800 border-adp-cyan-600': item.idPlataforma === 1,
        'bg-adp-green-100 text-adp-green-800 border-adp-green-400': item.idPlataforma === 2
      }"> -->
      <span class="badge badge-plataforma" [ngStyle]="colorPlatform">
        {{item.Plataforma}}
      </span>
    </div>
    <div *ngIf="xlabel === 2" class="badge--container">
      <span class="badge badge-nota" [ngStyle]="colorTipoNota">
        {{item.note}}
      </span>
    </div>
    <div *ngIf="xlabel === 3" class="badge--container">
      <span class="badge badge-tier" [ngStyle]="colorTier">
        TIER {{ item.tipoTier }}
      </span>
    </div>

    <!-- Lista de detalles -->


    <ul class="info-details">
      <li *ngIf="ylabel !== 1 || xlabel === 0"><strong>CAMPAÑA:</strong> {{item.Campaign}}</li>
      <li><strong>MEDIO:</strong> {{item.Medio}}</li>
      <li *ngIf="item.Programa"><strong>PROGRAMA:</strong> {{item.Programa}}</li>
      <li *ngIf="item.Vocero || item.voceros">
        <strong>VOCERO(S):</strong> {{ item.Vocero || item.voceros }}
      </li>   

      <li><strong>FECHA:</strong> {{item.fechaPublicacion | date:'dd-MM-yyyy'}}</li>
      <li *ngIf="item.url">
        <strong>LINK: </strong>
        <a (click)="goTo(item.url)" class="link">{{item.url}}</a>
      </li>
      <li *ngIf="ylabel !== 4 && xlabel !== 1"><strong>PLATAFORMA: </strong>{{item.Plataforma}}</li>
      <li *ngIf="item.idPlataforma === 9"><strong>RED:</strong> {{item.Clasificacion}}</li>
      <li *ngIf="item.idPlataforma === 5"><strong>SECCIÓN:</strong> {{item.MedioPlataforma}}</li>
      <li *ngIf="item.idPlataforma === 5 && det"><strong>CM<sup>2</sup>:</strong> {{item.cm2 ? [item.cm2 |
        number:'.2'] : '0.00'}} cm<sup>2</sup></li>
      <li *ngIf="(item.idPlataforma === 2 || item.idPlataforma === 3) && det"><strong>DURACIÓN:</strong>
        {{item.segundos ? item.segundos : '00:00'}} segundos</li>
      <li *ngIf="val"><strong>VALOR:</strong> {{item.valorizar | dolar:currency}}</li>
      <li *ngIf="det"><strong>ALCANCE:</strong> {{item.Alcance ? item.Alcance.toLocaleString() : 0}}</li>
    </ul>
  </section>
</div>